import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  OrganisationState,
  selectAllOrganisationUser,
} from '../reducers/organisation.reducer';

export const selectOrganisation =
  createFeatureSelector<OrganisationState>('organisation');

export const selectAllOrganisationUsers = createSelector(
  selectOrganisation,
  selectAllOrganisationUser,
);

export const selectOrganisationUserById = (id: string) =>
  createSelector(
    selectOrganisation,
    (state: OrganisationState) => state.entities[id],
  );

export const selectOrganisationStatePending = createSelector(
  selectOrganisation,
  ({ pending }) => pending,
);

export const selectOrganisationOrderOverview = createSelector(
  selectOrganisation,
  ({ orderOverview }) => orderOverview,
);

export const selectOrganisationUserOverview = createSelector(
  selectOrganisation,
  ({ userOverview }) => userOverview,
);

export const selectOrganisationUserOverviewStatePending = createSelector(
  selectOrganisation,
  ({ userOverviewPending }) => userOverviewPending,
);

export const selectOrganisationOrderOverviewStatePending = createSelector(
  selectOrganisation,
  ({ orderOverviewPending }) => orderOverviewPending,
);